import { type IRecord } from '@/interfaces'

export enum contactType {
	AP_Billing = 'AP/Billing',
	Purchasing = 'Purchasing',
	Client = 'Client'
}

export enum contactClass {
	Primary = 'Primary',
	Secondary = 'Secondary',
	Other = 'Other'
}

export interface IContact extends IRecord {
	id: string
	email?: string
	phone1?: string
	phone2?: string
	mobile?: string
	fax?: string
	firstName?: string
	middleName?: string
	lastName?: string
	position?: string
	title?: string
	address?: string
}
